export default __webpack_public_path__ + "static/media/error-info-icon.b049d92d.svg";